
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M13 22.347l6.871 6.976L33 16"}}),_c('path',{attrs:{"d":"M42.088 28.558c.594-1.915.912-3.949.912-6.06C43 11.179 33.821 2 22.501 2 11.18 2 2 11.178 2 22.499 2 33.822 11.179 43 22.501 43c5.333 0 10.176-2.056 13.822-5.394"}})])])
          )
        }
      }
    